export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';

export const toggleSpinner = (value: boolean) => ({
    type: TOGGLE_SPINNER,
    toggle: value
});
